import { useState } from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";
import { UploadPdfDropzone } from "./UploadPdfDropzone";

export type ConvertToPdfStepProps = {
  targetId: string;
  onComplete: () => void;
};

type AttachedFile = {
  objectKey: string;
  fileName: string;
};

// Uploads to S3 for real; no mutation yet to attach it to the request, so Continue doesn't persist.
export const ConvertToPdfStep = ({ onComplete }: ConvertToPdfStepProps) => {
  const [attachedFile, setAttachedFile] = useState<AttachedFile | null>(null);

  return (
    <Flex flexDirection="column" gap={SPACING.LARGE} className={styles.container}>
      <Text variant="h3">Attach a PDF version of this DDQ</Text>
      <Text variant="regular-md" color={Colors.Neutral600}>
        The source document isn&apos;t a PDF. Attach a PDF version to continue.
      </Text>
      <UploadPdfDropzone
        onFileUploaded={(objectKey, fileName) => setAttachedFile({ objectKey, fileName })}
      />
      {attachedFile && (
        <Text variant="regular-sm" data-testid="ddq-convert-pdf-attached-file">
          Attached: {attachedFile.fileName}
        </Text>
      )}
      <Flex justifyContent="flex-end">
        <Button
          onClick={onComplete}
          disabled={!attachedFile}
          data-testid="ddq-convert-pdf-continue"
        >
          Continue
        </Button>
      </Flex>
    </Flex>
  );
};
